module.exports = __webpack_public_path__ + "static/media/need-baby.547eec17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/need/need-baby.jpg
// module id = 364
// module chunks = 0